export default "__VITE_ASSET__3a4d7a78__"